module.exports = __webpack_public_path__ + "assets/b741c25c04560239d50edcd9aed747f7.jpg";